import React, { useState, useEffect } from 'react';
import "./App.css";
import Navbar from './components/Navbar';
import NeetBanner from './components/NeetBanner';
import NeetPredictor from './components/NeetPredictor';
import ScrollContainer from './components/ScrollContainer';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';
import CollegeInfoTabs from './components/CollegeInfoTabs';
import Testimonials from './components/Testimonials';
import About from './components/About';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

const App = () => {
  const [appData, setAppData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bannerShown, setBannerShown] = useState(true);

  useEffect(() => {
    fetch('/data.json')
      .then(response => response.json())
      .then(data => {
        setAppData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading data:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-base-light">
        <div className="text-lg font-medium text-primary-800">Loading guidance...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-base-light text-gray-800 relative font-sans">
      <NeetBanner shown={bannerShown} onDismiss={() => setBannerShown(false)} />
      <div className="relative">
        <Navbar
          consultancyName={appData?.educationConsultancy?.name}
          bannerShown={bannerShown}
        />
        <ScrollContainer>
          <Hero
            tagline={appData?.educationConsultancy?.tagline}
          />
          <NeetPredictor />
          <HowItWorks />
          <Services
            admissionServices={appData?.admissionServices}
          />
          <CollegeInfoTabs
            medicalColleges={appData?.medicalColleges}
            studyAbroad={appData?.studyAbroad}
          />
          <Testimonials />
          <About />
          <FAQ />
          <Contact
            contactInfo={appData?.educationConsultancy?.contact}
            address={appData?.educationConsultancy?.address}
          />
          <Footer
            contactInfo={appData?.educationConsultancy?.contact}
            address={appData?.educationConsultancy?.address}
          />
        </ScrollContainer>
      </div>
    </div>
  );
};

export default App;
